import React from 'react'
import styles from '../InternalExternalDetail.module.css'

const SectionHeader = ({ title, action = null }) => {
  return (
    <div className={styles.sectionHeader}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      {action}
    </div>
  )
}

export default SectionHeader